import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './components/App';
import Store from './redux/configureStore';
import {Provider} from 'react-redux';
import 'rxjs';
import * as serviceWorker from './serviceWorker';

//import initialState from './redux/reducers/initialState';
//const store = Store({initialState});

const store = Store({});

ReactDOM.render(
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>,
    document.getElementById('root')
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
